import React from "react";
import { Button, Popover } from "antd";

import { OrderExportResult } from "@/services/api/moreFeatures/orderExport";
import OrderExportField from "@/services/api/moreFeatures/orderExport/enum/Fields";
import { ReadonlyOrderExportFieldList } from "../OrderExportForm/FieldsFormItem";
import "./index.less";

interface TaskInfoItemProps {
    label: string;
    children: React.ReactNode;
}

export const TaskInfoItem: React.FC<TaskInfoItemProps> = ({ label, children }) => {
    return (
        <div className="order-export-task-info-item">
            <span className="order-export-task-info-label">{label}：</span>
            <div className="order-export-task-info-content">{children}</div>
        </div>
    );
};

interface TaskSettingsProps {
    fields?: OrderExportResult["fields"];
    totalOrderExportFields: OrderExportField[];
    needExportingOrderItems?: OrderExportResult["needExportingOrderItems"];
    needExportRefundOrderItems?: OrderExportResult["needExportRefundOrderItems"];
}

const TaskSettings: React.FC<TaskSettingsProps> = (props) => {
    const {
        fields,
        totalOrderExportFields,
        needExportingOrderItems,
        needExportRefundOrderItems,
    } = props;

    return (
        <div className="order-export-task-info">
            {needExportingOrderItems !== undefined ? (
                <TaskInfoItem label="商品信息">{needExportingOrderItems ? "导出" : "不导出"}</TaskInfoItem>
            ) : null}
            {needExportRefundOrderItems !== undefined ? (
                <TaskInfoItem label="退款中商品">
                    {needExportRefundOrderItems ? "导出" : "不导出"}
                </TaskInfoItem>
            ) : null}
            {fields !== undefined ? (
                <TaskInfoItem label="导出信息">
                    <Popover
                        trigger="click"
                        placement="top"
                        getPopupContainer={(triggerNode) => {
                            return (
                                (triggerNode.closest(".ant-modal") as HTMLElement) ||
                                (triggerNode.closest(".order-export-container") as HTMLElement) ||
                                document.body
                            );
                        }}
                        content={
                            <div className="order-export-task-settings-popover">
                                <ReadonlyOrderExportFieldList
                                    value={fields}
                                    allFields={totalOrderExportFields}
                                    needExportingOrderItems
                                />
                            </div>
                        }
                    >
                        <Button type="link" size="small" className="order-export-task-settings-link">
                            查看导出信息
                        </Button>
                    </Popover>
                </TaskInfoItem>
            ) : null}
        </div>
    );
};

export default React.memo(TaskSettings);
